import { z } from "zod";

function zodIssuesParser(error: z.ZodError): string {
  return error.issues.reduce(
    (prev, { code, message }) =>
      prev !== ""
        ? prev + ", " + `[${code}]: ${message}`
        : `[${code}]: ${message}`,
    "",
  );
}

function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return String(error);
}

export { zodIssuesParser, getErrorMessage };
